import { z } from "zod";

/**
 * Problem identity slug: names the underlying defect, never the page. Kebab-case
 * and colon-free so the issue fingerprint `yeet:<subject>:<problemKey>` splits
 * unambiguously (subjects are snake_case metrics or dotted subcriteria).
 */
export const ProblemKeySchema = z
  .string()
  .min(3)
  .max(64)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export type ProblemKey = z.infer<typeof ProblemKeySchema>;
